var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 216,
    viewBox: "0 0 278 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.666 21.2574L275.217 0.5745L311.768 21.2574V62.606L275.217 83.289L238.666 62.606V21.2574Z",
    stroke: "#EA3F33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.778 85.9642L237.329 65.2813L273.881 85.9642V127.313L237.329 147.996L200.778 127.313V85.9642Z",
    stroke: "#EA3F33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.465 150.671L199.016 129.988L235.567 150.671V192.02L199.016 212.703L162.465 192.02V150.671Z",
    stroke: "#EA3F33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0993 86.8158L83.6506 66.1328L120.202 86.8158V128.164L83.6506 148.847L47.0993 128.164V86.8158Z",
    stroke: "#EA3F33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3965 87.6671L81.9478 66.9842L118.499 87.6671V129.016L81.9478 149.699L45.3965 129.016V87.6671Z",
    fill: "#202022",
    stroke: "#202022"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.874 85.9642L159.426 65.2813L195.977 85.9642V127.313L159.426 147.996L122.874 127.313V85.9642Z",
    stroke: "#202022"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M200.778 87.6671L237.329 66.9842L273.881 87.6671V129.016L237.329 149.699L200.778 129.016V87.6671Z",
    stroke: "#202022"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M237.388 21.2574L273.94 0.5745L310.491 21.2574V62.606L273.94 83.289L237.388 62.606V21.2574Z",
    stroke: "#202022"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M161.188 152.374L197.739 131.691L234.29 152.374V193.722L197.739 214.405L161.188 193.722V152.374Z",
    fill: "#202022",
    stroke: "#202022"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23185 153.225L42.7831 132.542L79.3344 153.225V194.574L42.7831 215.257L6.23185 194.574V153.225Z",
    stroke: "#202022"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93467 150.671L44.486 129.988L81.0372 150.671V192.02L44.486 212.703L7.93467 192.02V150.671Z",
    stroke: "#EA3F33"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M162.465 21.2574L199.016 0.5745L235.567 21.2574V62.606L199.016 83.289L162.465 62.606V21.2574Z",
    fill: "#EA3F33",
    stroke: "#EA3F33"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M124.151 85.9642L160.703 65.2813L197.254 85.9642V127.313L160.703 147.996L124.151 127.313V85.9642Z",
    stroke: "#EA3F33"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormas);
export default __webpack_public_path__ + "static/media/formas.9f8fd7c55e66c0a6c6fa16592ffc73f3.svg";
export { ForwardRef as ReactComponent };